import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsWindsurfNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M29.592 0h4.13c.864 0 1.798.326 2.452 1.108C37.856 3.118 42 9.37 42 22c0 7.706-1.542 13.4-3.114 17.198A30.637 30.637 0 0137.563 42H48v3H10v-3h24.087l.082-.13c.172-.272.365-.593.572-.963L10.208 31H4v-3h5.681L26.648 1.607A3.5 3.5 0 0129.592 0zM18.22 31l17.832 7.201.062-.15c.755-1.825 1.519-4.169 2.07-7.051zm20.43-3c.22-1.825.35-3.824.35-6H25v-3h13.914a44.728 44.728 0 00-.275-3H29v-3h9.142a32.612 32.612 0 00-.77-3H33V7h3.25c-.937-2.094-1.874-3.366-2.377-3.967l-.002-.002a.094.094 0 00-.018-.01.344.344 0 00-.131-.021h-4.13a.5.5 0 00-.42.23L13.246 28z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWindsurfNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsWindsurfNormalLarge;
